import { render, staticRenderFns } from "./IPAddresses.vue?vue&type=template&id=052a28c4&scoped=true"
import script from "./IPAddresses.vue?vue&type=script&lang=js"
export * from "./IPAddresses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052a28c4",
  null
  
)

export default component.exports